module.exports = [
	{
		"id": "default",
		"title": "Sentry®Safe Security Family Video",
		"category": "Self-Help",
		"tag": "Self-Help X014E X041E X055 X075 X105 X105P X125",
		"videoId": "6209411648001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "801",
		"title": "Sentry®Safe Security Family Video",
		"category": "Self-Help",
		"tag": "Self-Help X014E X041E X055 X075 X105 X105P X125",
		"videoId": "6209411648001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "802",
		"title": "SentrySafe Chest/File Fire & Water Family Video",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6209408371001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "803",
		"title": "SentrySafe Chest/File Fire Family Video",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6209408069001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "804",
		"title": "SentrySafe CHW30300 Digital Chest: 360 Degree Overview",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6209405835001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "805",
		"title": "SentrySafe FHW40300 Digital File Safe: 360 Degree Overview",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6209405833001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "806",
		"title": "Sentry®Safe Fire/Water Resistant 1-Hour Safes vs Competition",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6209403744001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "807",
		"title": "Sentry®Safe Fire/Water Resistant 2-Hour Safes vs Competition",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6209411646001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "808",
		"title": "Large Commercial Fire Resistant Safe from SentrySafe",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6209408068001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "809",
		"title": "Sentry®Safe Pistol Safe - SentrySafe Quick Access Biometric Pistol Safe",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6209406335001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "810",
		"title": "Portable Security Chest P005C from SentrySafe",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6209405834001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "811",
		"title": "SentrySafe PP1K Pistol Safe: 360 Degree Overview",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6209411647001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "812",
		"title": "SentrySafe QAP1BE: Quick Access Biometric Pistol Safe",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6209410283001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "813",
		"title": "SentrySafe QAP1E: Quick Access Electronic Pistol Safe",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6209412330001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "814",
		"title": "SentrySafe QAP2BEL: XL Quick Access Biometric Pistol Safe",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6209410286001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "815",
		"title": "SentrySafe QAP2E: XL Quick Access Electronic Pistol Safe",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6209411225001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "816",
		"title": "SentrySafe QAP2EL: XL Quick Access Electronic Pistol Safe",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6209410285001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "817",
		"title": "SentrySafe QAP2EL: XL Quick Access Electronic Pistol Safe",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6211236473001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "818",
		"title": "Sentry®Safe Fire Resistant Document Bag",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6268596965001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "819",
		"title": "Sentry®Safe Total Fire Protection",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6273722755001",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "820",
		"title": "Sentry®Safe FP Series Fireproof Safes",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6316737788112",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	},
	{
		"id": "821",
		"title": "Sentry®Safe FP Series Fire Protection & Testing Standards",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"videoId": "6329986431112",
		"header": "Watch Videos For Your Safe",
		"subheader": ""
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/support/videos/email/emailVideoData.json
// module id = 750
// module chunks = 0